// @flow
import React, { Component } from 'react';
import { NavHashLink as NavLink, HashLink as Link } from 'react-router-hash-link';

import styles from '../../styles/PharmacySidebarMenu.scss';

type Props = {
  match: Object,
}

class PharmacySidebarMenu extends Component<Props> {
  render() {
    const { match } = this.props;
    const path = window.location.pathname;

    return (
      <div className={styles.sidebarMenu}>
        <ul className={styles.menuList}>
          <li>
            <NavLink activeClassName={styles.activeLink} to={`${match.url}/inventory`} exact={true}>
              Inventory
            </NavLink>
            {path.includes('inventory')
              && <ul className={styles.subLinks}>
                <li>
                  <Link to={`${match.url}/inventory#allergymedicine`} smooth>
                    Allergy medicine
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#antibiotics`} smooth>
                    Antibiotics
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#antiepileptics`} smooth>
                    Anti-epileptics
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#antifungals`} smooth>
                    Antifungals
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#antivirals`} smooth>
                    Antivirals
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#respiratory`} smooth>
                    Respiratory Meds
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#decongestants`} smooth>
                    Decongestants
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#steroids`} smooth>
                    Steroids
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#supplements`} smooth>
                    Supplements
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#immunizations`} smooth>
                    Immunizations
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#analgesics`} smooth>
                    Analgesics
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#adhd`} smooth>
                    ADHD Meds
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#gi`} smooth>
                    GI Meds
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#muscleRelaxants`} smooth>
                    Muscle Relaxants
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/inventory#other`} smooth>
                    Other
                  </Link>
                </li>
              </ul>
            }
          </li>
          <br />
          <li>
            <NavLink activeClassName={styles.activeLink} to={`${match.url}/stock`} exact={true}>
              Stock Report
            </NavLink>
            {path.includes('stock')
              && <ul className={styles.subLinks}>
                <li>
                  <Link to={`${match.url}/stock#outOfStock`} smooth>
                    Out of Stock
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/stock#lowStock`} smooth>
                    Low Stock
                  </Link>
                </li>
              </ul>
            }
          </li>
          <br />
          <li>
            <NavLink activeClassName={styles.activeLink} to={`${match.url}/expiration`} exact={true}>
              Expiration Report
            </NavLink>
            {path.includes('expiration')
              && <ul className={styles.subLinks}>
                <li>
                  <Link to={`${match.url}/expiration#expired`} smooth>
                    Expired
                  </Link>
                </li>
                <li>
                  <Link to={`${match.url}/expiration#expiring`} smooth>
                    Expiring
                  </Link>
                </li>
              </ul>
            }
          </li>
          <br />
          <li><NavLink activeClassName={styles.activeLink} to={`${match.url}/archived`}>Archive</NavLink></li>
          <br />
          <li><NavLink activeClassName={styles.activeLink} to={`${match.url}/transactionReport`}>Transaction Report</NavLink></li>
          <br />
          <li><NavLink activeClassName={styles.activeLink} to={`${match.url}/dispensaryReport`}>Dispensary Report</NavLink></li>
        </ul>
      </div>
    );
  }
}

export default PharmacySidebarMenu;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/PharmacySidebarMenu.jsx